import { render, staticRenderFns } from "./TheMenuRightItem.vue?vue&type=template&id=59664ed6&scoped=true&"
import script from "./TheMenuRightItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuRightItem.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuRightItem.vue?vue&type=style&index=0&id=59664ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59664ed6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tooltip: require('/app/components/partials/Tooltip.vue').default})
